module.exports = __webpack_public_path__ + "img/svg/increment-arrow.d2031bc748d695487e75721a7c86983a.svg";